import { Box } from '@mui/material';
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import SnackbarNotifications from 'e.sic-platform.webclient/src/components/snackbar-notifications/SnackbarNotifications';
import DownloadPanel from '../download-panel/DownloadPanel';
import RestoreProgressPanel from '../restore/RestoreProgressPanel';
import { useState } from 'react';

export default function Layout(props:{children:any}) {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <>
            <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
            <Box sx={{ display: 'flex', flexDirection: 'column', overflowX: 'clip', width: '100%', maxWidth: '100vw', minHeight: '100vh' }}>
                <Box
                    data-layout-content="true"
                    sx={theme => ({
                        transition: theme.transitions.create('margin-left', {
                            duration: theme.transitions.duration.standard,
                            easing: theme.transitions.easing.easeInOut,
                        }),
                        mt: 7, ml: {sm: menuOpen ? '195px' : '66px', xs: 0},
                        overflowX: 'clip',
                        minWidth: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 'calc(100vh - 56px)',
                        })}
                        >
                    <Box sx={{ flex: 1 }}>
                        {props.children}
                    </Box>
                    <Footer />
                </Box>
            </Box>
            <Box sx={{ position: 'fixed', bottom: 0, zIndex: 100, width: '100%' }}>
                <SnackbarNotifications />
            </Box>
            <DownloadPanel />
            <RestoreProgressPanel />
        </>
    )
}
